/**
 * Maps headingData.field values to INFO_TEXT_MESSAGE keys.
 * Used by TableHeadItem to look up tooltip text for each column's info icon.
 */
export const FIELD_TO_INFO_KEY = {
  // Publication details
  doi: "DOI",
  title: "ARTICLE_TITLE",
  authors: "AUTHORS",
  journalName: "JOURNAL",
  licenseType: "LICENSE_TYPE",
  licenseUrl: "LICENSE_URL",
  licenseDate: "REUSE_LICENSE_START_DATE",
  funders: "FUNDERS",
  datasetsDli: "DATASET_URL",
  onlinePublicationDate: "ONLINE_PUBLICATION_DATE",
  printPublicationDate: "PRINT_PUBLICATION_DATE",
  lastAudit: "LAST_AUDITED",
  publiclyAccessibleDate: "OPEN_ACCESS_ON_PUBLISHER_SITE",
  createdAtDate: "ADDED",
  updatedAtDate: "UPDATED",

  // Grant / funder detail fields
  grantId: "GRANT_ID",
  funderId: "FUNDER_ID",
  funderIds: "FUNDER_ID",
  funderRorIds: "FUNDER_ROR_ID",
  agencyPortalUrls: "FUNDER_PORTAL_URLS",
  archivedStatus: "ARCHIVED_STATUS",
  auditSource: "AUDIT_SOURCE",
  auditedOnDate: "LAST_AUDITED",
  funderSource: "FUNDER_SOURCE",
  retracted: "RETRACTED",
  type: "TYPE",
  publicationType: "TYPE",

  // Publisher
  publisher: "PUBLISHER",
};

export const INFO_TEXT_MESSAGE = {
  RETRACTED: "Links to the retracted DOI.",
  FUNDERS:
    "Funders as registered at Crossref by Publishers and linked to the associated ROR ID.",
  FUNDER_ID:
    "Funder ID as registered at Crossref by Publishers and linked to the associated ROR ID.",
  FUNDER_ROR_ID:
    "Funder ROR ID associated with Funder.",
  ONLINE_PUBLICATION_DATE:
    "Online Publication Date registered at Crossref by Publishers.",
  PRINT_PUBLICATION_DATE:
    "Print Publication Date registered at Crossref by Publishers.",
  LAST_AUDITED:
    "Date last audited for public accessibility on the publishers site by CHORUS.",
  OPEN_ACCESS_ON_PUBLISHER_SITE:
    "The date the article is expected to be publicly accessible on the publishers’ site as indicated by Reuse License metadata recorded with CHORUS",
  LICENSE_TYPE: "Open Access License Type associated with the DOI",
  REUSE_LICENSE_START_DATE:
    "Start date of the Reuse License recorded with CHORUS",
  FUNDER_PORTAL_URLS: "Content that has been found to be on an funder portal.",
  GRANT_ID: "Funders Internal Grant ID",
  ARCHIVED_STATUS: "DOIs ingested for preservation in CLOCKSS or Portico.",
  DATASET_URL: "Dataset links supplied by Scholix DLI Service",
  AUDIT_SOURCE: "Source used to audit content",
  FUNDER_SOURCE: "Source for identifying funder",

  DOI: "",
  PUBLISHER: "",
  AUTHORS: "",
  ARTICLE_TITLE: "",
  JOURNAL: "",
  LICENSE_URL: "",
  TYPE: "",
  ADDED: "",
  UPDATED: "",
};
